module.exports = __webpack_public_path__ + "47e6080bac14f21108ab6c4d83e63027.png";